<ng-container *ngIf="step === 2">
  <ng-container *ngIf="!isAggregationComplete()" [ngTemplateOutlet]="loaderPage"></ng-container>
  <ng-container *ngIf="isAggregationComplete()">
    <div class="main-container">
      <img class="tick-image mx-auto" src="assets/icons/b-icons-06-system-sys-037-tick-in-a-circle.svg" alt="">
      <h1 class="w-full text-center mb-6"><strong>{{'messages.connected' |
          translate}}&nbsp;{{getSelectedEntityName()}}</strong></h1>
          <div class="action-buttons mb-5">
            <button class="btn" type="button" id="notaddmoreproducts" (click)="exit()">{{'general.continue_process' |
              translate}}</button>
          </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="step===-1">
  <app-ag-error *ngIf="error === 400" [errorTitle]="'errors.400.title' | translate"
    [errorDescription]="'errors.400.description' | translate" [buttonText]="'errors.400.button' | translate"
    (buttonClick)="retry()"></app-ag-error>
  <app-ag-error *ngIf="error === 500" [errorTitle]="'errors.500.title' | translate"
    [errorDescription]="'errors.500.description' | translate" [buttonText]="'errors.500.button' | translate"
    (buttonClick)="retry()"></app-ag-error>
</ng-container>

<ng-template #loaderPage>
  <div class="main-container">
    <div class="flex flex-col justify-content-center items-center mb-5">
      <app-spinner class="w-full py-4"></app-spinner>
      <h2 class="w-full text-center"><strong>{{'WAITING-ENTITY-INFO' | translate}}</strong></h2>
    </div>
  </div>
</ng-template>